import React from 'react'
import './TutorialVideo.css'

const TutorialVideo = ({ sectionHeading, videoData }) => {
    
    return (
        <section className="tutorial-video-section">
            <div className="container">
                <div className="tutorial-video-main">
                    {sectionHeading&& 
                    <div className="video-section-heading">
                        {/* === Video Heading === */}
                        <h2 className="v-heading">{sectionHeading ? sectionHeading : "Section name"}</h2>
                    </div>}
                    <div className="tutorial-all-video">
                        {/* === Video Loop === */}
                        {
                            videoData.map((video, index) => {
                                return(
                                    <div className="tutorial-video-item" key={`VIDEO${index}HJSIS894`}>
                                        <iframe className="tutorial-video-player" frameBorder="0" allowFullScreen="1" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" src={`${video.videoOrigin}${video.shearingType}/${video.videoId}?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Felitepartyz.com&amp;widgetid=1`} id="widget2"></iframe>
                                        <h4 className="video-title">{video.videoTitle}</h4>
                                        <p className="video-description">{video.videoDes}</p>
                                    </div>
                                )
                            })
                        }
                        
                        

                    </div>
                </div>
            </div>
        </section>
    )
}

export default TutorialVideo
